<template>
  <section id="settings-view" class="settings columns">
    <div class="column is-one-fifth">
      <SideMenu/>
    </div>

    <div class="column is-two-fifths">
      <div class="box settings-content">
        <router-view></router-view>
      </div>
    </div>
  </section>
</template>

<script>
import SideMenu from '@/views/Settings/SideMenu.vue'
export default {
  components: {
    SideMenu
  }
}
</script>
